module.exports = {
          srcSet: __webpack_public_path__ + "9115a3c5422e12c98b3f1aee65badabf-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "9115a3c5422e12c98b3f1aee65badabf-1920.png",width: 1920,height: 594}],
          src: __webpack_public_path__ + "9115a3c5422e12c98b3f1aee65badabf-1920.png",
          toString:function(){return __webpack_public_path__ + "9115a3c5422e12c98b3f1aee65badabf-1920.png"},
          
          width: 1920,
          height: 594
        }